import PromiseWorker from "promise-worker-transferable";
export class AnalyzerProvider {
    constructor(path) {
        this.promiseWorker = new PromiseWorker(new Worker(path, { name: "hash-analyzer" }));
    }
    async analyze(state) {
        return this.promiseWorker.postMessage({ type: "analyze", data: state }, []);
    }
    async setAnalysisSrc(src) {
        return this.promiseWorker.postMessage({ type: "setAnalysisSrc", src }, []);
    }
}
//# sourceMappingURL=wrapper.js.map